'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _template = require('../actions/template');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FILTER = {
    status: -1,
    type: -1,
    keyword: ''
};
var filter = function filter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FILTER;
    var action = arguments[1];

    switch (action.type) {
        case _template.FILTER_TEMPLATES:
            return Object.assign({}, state, action.filter);
        default:
            return state;
    }
};

var INITIAL_STATE = {
    isPosting: false,
    isFetching: false,
    isDeleting: false,
    didInvalidate: false,
    items: [],
    pagination: {}
};
var templates = function templates() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _template.INVALIDATE_TEMPLATES:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _template.REQUEST_TEMPLATES:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _template.RECEIVE_TEMPLATES:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.templates,
                pagination: action.pagination,
                lastUpdated: action.received_at
            });
        case _template.FAILURE_TEMPLATES:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        case _template.POST_TEMPLATE_REQUEST:
            return _extends({}, state, {
                isPosting: true
            });
        case _template.POST_TEMPLATE_SUCCESS:
            return _extends({}, state, {
                isPosting: false
            });
        case _template.POST_TEMPLATE_FAILURE:
            return _extends({}, state, {
                isPosting: false
            });
        case _template.DELETE_TEMPLATE_REQUEST:
            return _extends({}, state, {
                isDeleting: true
            });
        case _template.DELETE_TEMPLATE_SUCCESS:
            return _extends({}, state, {
                isDeleting: false
            });
        case _template.DELETE_TEMPLATE_FAILURE:
            return _extends({}, state, {
                isDeleting: false
            });
        default:
            return state;
    }
};

var templateReducer = (0, _redux.combineReducers)({
    templates: templates,
    filter: filter
});

exports.default = templateReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/template.js
// module id = 879
// module chunks = 0